var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCourseIntro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-44 65)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17 47)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2772 -3271)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2845.5,
    cy: 3171.5,
    r: 12.5
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2785 -2858.725)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M2797.5,2866.7c-3,0.1-5.8,1.7-7.5,4.2c-0.2,0.2-0.2,0.5,0,0.7c1.7,2.5,4.5,4.1,7.5,4.2   c3-0.1,5.8-1.7,7.5-4.2c0.2-0.2,0.2-0.5,0-0.7C2803.3,2868.3,2800.5,2866.8,2797.5,2866.7z M2797.7,2874.4c-1.8,0.1-3.3-1.2-3.4-3   c-0.1-1.8,1.2-3.3,3-3.4c1.8-0.1,3.3,1.2,3.4,3c0,0.1,0,0.3,0,0.4C2800.6,2873,2799.3,2874.3,2797.7,2874.4L2797.7,2874.4z    M2797.6,2873c-1,0.1-1.8-0.7-1.8-1.6c-0.1-1,0.7-1.8,1.6-1.8c1-0.1,1.8,0.7,1.8,1.6c0,0.1,0,0.1,0,0.2   C2799.2,2872.2,2798.5,2872.9,2797.6,2873L2797.6,2873z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCourseIntro);
export default __webpack_public_path__ + "static/media/icon-course-intro.1ab5d47da50afa83183db8cbc3226291.svg";
export { ForwardRef as ReactComponent };